/**
 * @description 生成随机字符串
 * @param {number} count 生成字符的个数
 */
export function randomString(count) {
  const strArr = []
  for(let i = 0 ; i < count; i++) {
    const code = parseInt(Math.random() * 26) + 65
    strArr[i] = String.fromCharCode(code)
  }
  return strArr.join('')
}